<template>
  <div class="prizes-2021-section-place">{{ place }} место</div>
</template>

<script>
export default {
  name: "Prizes2021SectionPlace",
  props: {
    place: {
      type: [Number, String],
      required: true
    }
  }
};
</script>

<style lang="scss">
.prizes-2021-section-place {
  width: 245px;
  height: 65px;

  margin: 0 auto 25px;

  display: flex;
  align-items: center;
  justify-content: center;

  text-align: center;
  border-radius: 35px;

  font-size: 20px;
  font-weight: 800;

  background-image: linear-gradient(to bottom, #12182f, #1d3063);

  @include breakpoint("sm-and-down") {
    width: 205px;
    height: 55px;
    font-size: 18px;
  }

  @include breakpoint("xs-only") {
    width: 155px;
    height: 45px;
    font-size: 16px;
  }
}
</style>
